import React from 'react';
import ArrowLeft from 'assests/icons/arrow-left';
import UserIcon from 'assests/icons/user.icon';
import MessageIcon from 'assests/icons/message.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import classNames from 'classnames';
import moment from 'moment';
import './phone.less';

const Phone = (props) => {
  return (
    <div className={classNames('phone', { 'phone--lock': props.lockScreen })}>
      {props.lockScreen ? (
        <div className="phone__body">
          <span className="phone__clock">{moment().format('HH:mm')}</span>
          <span className="phone__date">{moment().format('dddd, d MMM')}</span>
          <div className="message">
            <div className="message__left">
              <div className="message__detail">
                <MessageIcon />
                <span>Messenger</span>
                <span className="message__time">1d</span>
                <DownChevronIcon />
              </div>
              <span className="message__title">
              {props.title ? props.title : 'Ünvanınız'}
              </span>
              <span className="message__text">
              {props.message==='' ?  <p>Mesaj Metniniz</p> : props.message }
              </span>
            </div>
            <div className="message__right">U</div>
          </div>
        </div>
      ) : (
        <>
          <div className="phone__header">
            <span className="phone__time">{moment().format('HH:mm')}</span>
            <span className="phone__title">
              <ArrowLeft />
              {props.title ? props.title : 'Ünvanınız'}
            </span>
          </div>
          <div className="phone__content">
            <div className="message__row">
              <div>
                <UserIcon />
              </div>
              <div style={{whiteSpace:'pre-wrap'}}>{props.message==='' ?  <p>Mesaj Metniniz</p> : props.message }</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Phone;
